import React from "react";
import QuotationSort from "./QuotationSort";
import QuotationFilter from "./QuotationFilter";

// Panneau repliable tri/filtres — l'ouverture est pilotée par la roue
// crantée du QuotationHeaderBar.
const QuotationParameters = ({
  isParametersOpen,
  sort,
  setSort,
  filters,
  setFilters,
  constantData,
}) => {
  if (!isParametersOpen) return null;

  return (
    <div className="col-12 no-print">
      <div
        className="mt-3 mb-3 p-3"
        style={{
          background: "#f8f9fa",
          border: "1px solid #dee2e6",
          borderRadius: "0.25rem",
        }}
      >
        <div className="row">
          <div className="col-md-3">
            <h4>Trier</h4>
            <QuotationSort sort={sort} setSort={setSort} />
          </div>
          <div className="col-md-9">
            <h4>Filtrer</h4>
            <QuotationFilter
              filters={filters}
              setFilters={setFilters}
              constants={constantData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationParameters;
